export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "health_report": "ఆరోగ్య నివేదిక",
    "astrological_health_insights": "జ్యోతిష్య ఆరోగ్య అంతర్దృష్టులు",
    "health_report_description": "వేద జ్యోతిష్యం ఆధారంగా సమగ్ర ఆరోగ్య విశ్లేషణను పొందండి. మీ ఆరోగ్య బలహీనతలు, వ్యాధి ప్రవృత్తులు, నివారణ మరియు సంరక్షణ చర్యలు, అలాగే అనుకూల క్షేమం కోసం వ్యక్తిగతీకరించిన సిఫార్సులను తెలుసుకోండి.",

    // Service Information
    "enter_details_for_health_analysis": "ఆరోగ్య విశ్లేషణ కోసం మీ వివరాలను నమోదు చేయండి",
    "complete_health_analysis": "పూర్ణ ఆరోగ్య విశ్లేషణ",
    "service_price": "సేవా ధర",
    "comprehensive_health_analysis_note": "మీ ఆరోగ్య నమూనాల లోతైన విశ్లేషణ మరియు వ్యక్తిగతీకరించిన ఆరోగ్య మార్గదర్శనం",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "name_health_influence": "మీ పేరు కంపనలు మీ ఆరోగ్యం మరియు వైద్య నమూనాలను ప్రభావితం చేస్తాయి",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_health_insights": "ఆరోగ్య-సంబంధిత గ్రహ స్థానాలను నిర్ధారించడానికి అవసరం",
    "time_of_birth": "జన్మ సమయం",
    "exact_time_critical_for_health": "ఖచ్చితమైన ఆరోగ్య భావ గణనల కోసం ఖచ్చితమైన సమయం అవసరం",
    "place_of_birth": "జన్మ స్థలం",
    "place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
    "location_essential_for_health": "స్థానం ఆరోగ్యాన్ని ప్రభావితం చేసే గ్రహ స్థానాలను ప్రభావితం చేస్తుంది",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ ఆరోగ్య విశ్లేషణ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Health Features
    "health_vulnerabilities_analysis": "ఆరోగ్య బలహీనతల విశ్లేషణ",
    "disease_predisposition_insights": "వ్యాధి ప్రవృత్తి అంతర్దృష్టులు",
    "preventive_health_measures": "నివారణ ఆరోగ్య చర్యలు",
    "dietary_lifestyle_recommendations": "ఆహార మరియు జీవనశైలి సిఫార్సులు",
    "healing_gemstones_remedies": "వైద్య రత్నాలు మరియు పరిహారాలు",
    "pdf_download": "సమగ్ర PDF నివేదిక",

    "what_you_get": "మీ ఆరోగ్య విశ్లేషణలో ఉన్నవి",
    "comprehensive_health_chart": "సమగ్ర ఆరోగ్య చార్ట్",
    "body_system_analysis": "శరీర వ్యవస్థ విశ్లేషణ",
    "preventive_care_guidance": "నివారణ సంరక్షణ మార్గదర్శనం",
    "wellness_enhancement_tips": "ఆరోగ్య మెరుగుదల చిట్కాలు",

    // Actions & Buttons
    "pay_and_generate_analysis": "నా ఆరోగ్య విశ్లేషణ పొందండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "విశ్లేషణను రూపొందిస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "health_analysis_processing": "మీ ఆరోగ్య విశ్లేషణ మా నిపుణ వైద్య జ్యోతిష్యులచే తయారు చేయబడుతోంది. మీ ఆరోగ్య నమూనాలు మరియు వ్యక్తిగతీకరించిన ఆరోగ్య మార్గదర్శనంపై వివరణాత్మక అంతర్దృష్టులు అందుకుంటారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_12_hours_delivery_note": "మీ వివరణాత్మక ఆరోగ్య నివేదిక 12 గంటలలోపు తయారవుతుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్‌లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్‌లను అందుకోండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి విశ్లేషణ అందించబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ ఆరోగ్య విశ్లేషణ ప్యాకేజ్",
    "detailed_health_report": "సమగ్ర ఆరోగ్య నివేదిక (PDF)",
    "body_system_vulnerability_analysis": "శరీర వ్యవస్థ బలహీనత విశ్లేషణ",
    "preventive_healthcare_plan": "నివారణ ఆరోగ్య సంరక్షణ ప్రణాళిక",
    "dietary_wellness_guidelines": "ఆహార మరియు ఆరోగ్య మార్గదర్శకాలు",
    "healing_remedies_recommendations": "వైద్య పరిహారాలు మరియు సిఫార్సులు",

    // Visual Content
    "sample_health_analysis": "నమూనా ఆరోగ్య విశ్లేషణ",
    "health_strength_indicator": "ఆరోగ్య బలం సూచిక",
    "sample_health_reading": "హృదయ ఆరోగ్య క్షేమంపై దృష్టితో బలమైన జీవశక్తి",
    "sample_health_preview": "వ్యవస్థ అంతర్దృష్టులతో మీ వ్యక్తిగత ఆరోగ్య విశ్లేషణ మునుజూపు",
    "health_categories": "ఆరోగ్య వర్గాలు",

    // Health System Types
    "cardiovascular": "హృదయ రక్తనాళ వ్యవస్థ",
    "neurological": "నాడీ వ్యవస్థ", 
    "respiratory": "శ్వాస వ్యవస్థ",
    "digestive": "జీర్ణ వ్యవస్థ",
    "skeletal": "అస్థి వ్యవస్థ",
    "immune_system": "రోగనిరోధక వ్యవస్థ",

    // Status & Processing
    "your_health_analysis_status": "మీ ఆరోగ్య విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ ఆరోగ్య నమూనాలను విశ్లేషిస్తోంది",
    "analysis_processing_message": "మా వైద్య జ్యోతిష్య నిపుణులు మీ ఆరోగ్య బలహీనతలు మరియు ఆరోగ్య సిఫార్సులను నిర్ధారించడానికి మీ గ్రహ స్థానాలను అధ్యయనం చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో ఉంది",
    "pending": "వేచి ఉంది",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్‌లు ప్రారంభించబడ్డాయి",
    "delivery_within_12_hours": "12 గంటలలోపు నివేదిక సిద్ధం",

    // Support & Contact
    "contact_support": "ఆరోగ్య మద్దతును సంప్రదించండి",
    "need_help": "మార్గదర్శనం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని జన్మ వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Health-Specific Elements
    "sixth_house": "6వ భావం (ఆరోగ్య భావం)",
    "eighth_house": "8వ భావం (దీర్ఘకాలిక ఆరోగ్యం)",
    "twelfth_house": "12వ భావం (ఆసుపత్రిలో చేరడం)",
    "ascendant_health": "లగ్నం మరియు మొత్తం జీవశక్తి",
    "moon_health": "చంద్రుడు మరియు మానసిక ఆరోగ్యం",
    "mars_energy": "మంగళ మరియు శారీరక శక్తి",

    // Body Systems Analysis
    "circulatory_system": "రక్త ప్రసరణ వ్యవస్థ",
    "nervous_system": "నాడీ వ్యవస్థ",
    "respiratory_system": "శ్వాస వ్యవస్థ",
    "digestive_system": "జీర్ణ వ్యవస్థ",
    "musculoskeletal_system": "కండర అస్థి వ్యవస్థ",
    "endocrine_system": "అంతస్రావ వ్యవస్థ",
    "reproductive_system": "పునరుత్పత్తి వ్యవస్థ",
    "excretory_system": "విసర్జన వ్యవస్థ",

    // Health Vulnerabilities
    "genetic_predispositions": "వంశపారంపర్య ప్రవృత్తులు",
    "chronic_condition_risks": "దీర్ఘకాలిక వ్యాధి ప్రమాదాలు",
    "acute_illness_patterns": "తీవ్ర అనారోగ్య నమూనాలు",
    "mental_health_factors": "మానసిక ఆరోగ్య కారకాలు",
    "stress_vulnerability": "ఒత్తిడి బలహీనత ప్రాంతాలు",
    "injury_prone_areas": "గాయం అయ్యే అవకాశం ఉన్న ప్రాంతాలు",

    // Preventive Measures
    "early_warning_signs": "ముందస్తు హెచ్చరిక సంకేతాలు",
    "regular_checkup_schedule": "నియమిత తనిఖీ షెడ్యూల్",
    "screening_recommendations": "ఆరోగ్య పరీక్ష సిఫార్సులు",
    "vaccination_guidance": "టీకా మార్గదర్శనం",
    "lifestyle_modifications": "జీవనశైలి మార్పులు",
    "exercise_prescriptions": "వ్యాయామం సూచనలు",

    // Dietary Recommendations
    "constitutional_diet": "రాజ్యాంగిక ఆహార ప్రణాళిక",
    "foods_to_include": "చేర్చవలసిన ఆహారాలు",
    "foods_to_avoid": "తప్పించవలసిన ఆహారాలు",
    "meal_timing": "అనువైన భోజన సమయం",
    "seasonal_adjustments": "కాలానుగుణ ఆహార మార్పులు",
    "supplementation_needs": "పూరక ఆహార అవసరాలు",

    // Lifestyle Guidance
    "sleep_patterns": "అనువైన నిద్ర నమూనాలు",
    "exercise_routine": "సిఫార్సు చేయబడిన వ్యాయామం",
    "stress_management": "ఒత్తిడి నిర్వహణ పద్ధతులు",
    "work_life_balance": "పని-జీవిత సంతులనం",
    "environmental_factors": "పర్యావరణ ఆరోగ్య కారకాలు",
    "social_health": "సామాజిక మరియు భావోద్వేగ ఆరోగ్యం",

    // Healing & Remedies
    "ayurvedic_remedies": "ఆయుర్వేద పరిహారాలు",
    "herbal_recommendations": "మూలికా సిఫార్సులు",
    "gemstone_therapy": "రత్న చికిత్స",
    "color_therapy": "రంగు చికిత్స",
    "sound_healing": "శబ్ద వైద్యం",
    "yoga_practices": "చికిత్సా యోగ అభ్యాసాలు",
    "meditation_techniques": "వైద్య ధ్యాన పద్ధతులు",
    "breathing_exercises": "ప్రాణాయామం మరియు శ్వాస వ్యాయామాలు",

    // Mental Health
    "psychological_patterns": "మానసిక నమూనాలు",
    "emotional_balance": "భావోద్వేగ సంతులనం",
    "mental_clarity": "మానసిక స్పష్టత మెరుగుదల",
    "memory_concentration": "జ్ఞాపకశక్తి మరియు దృష్టి",
    "anxiety_management": "ఆందోళన నిర్వహణ",
    "depression_prevention": "డిప్రెషన్ నివారణ",

    // Timing & Cycles
    "health_cycles": "వ్యక్తిగత ఆరోగ్య చక్రాలు",
    "vulnerable_periods": "ఆరోగ్య బలహీనత కాలాలు",
    "recovery_periods": "సహజ స్వాస్థ్య లాభ కాలాలు",
    "optimal_treatment_timing": "అనువైన చికిత్స సమయం",
    "surgery_timing": "శస్త్రచికిత్స ప్రక్రియ సమయం",
    "detox_periods": "విషనాశన కాలాలు",

    // Age-Related Health
    "childhood_health": "బాల్యం ఆరోగ్య నమూనాలు",
    "adolescent_health": "కిశోర వయస్సు ఆరోగ్య సమస్యలు",
    "adult_health": "వయోజన ఆరోగ్య నిర్వహణ",
    "middle_age_concerns": "మధ్య వయస్సు ఆరోగ్య ఆందోళనలు",
    "senior_health": "వృద్ధాప్య ఆరోగ్య మార్గదర్శనం",
    "longevity_factors": "దీర్ఘాయువు కారకాలు",

    // Women's Health
    "menstrual_health": "రుతుకాల ఆరోగ్యం",
    "fertility_factors": "సంతానోత్పత్తి కారకాలు",
    "pregnancy_guidance": "గర్భధారణ ఆరోగ్య మార్గదర్శనం",
    "menopause_management": "రుతుక్రమ విరామ నిర్వహణ",
    "hormonal_balance": "హార్మోన్ సంతులనం",

    // Men's Health
    "vitality_enhancement": "జీవశక్తి మెరుగుదల",
    "prostate_health": "ప్రోస్టేట్ ఆరోగ్యం",
    "testosterone_balance": "టెస్టోస్టెరాన్ సంతులనం",
    "cardiovascular_focus": "హృదయ రక్తనాళ దృష్టి",
    "stress_related_issues": "ఒత్తిడి-సంబంధిత సమస్యలు",

    // Specialty Areas
    "skin_health": "చర్మం మరియు అందమైన ఆరోగ్యం",
    "eye_health": "కంటి ఆరోగ్యం",
    "dental_health": "దంత ఆరోగ్యం",
    "hair_health": "జుట్టు ఆరోగ్యం",
    "joint_health": "కీలుల ఆరోగ్యం",
    "metabolic_health": "జీవక్రియ ఆరోగ్యం",

    // Emergency Preparedness
    "health_emergencies": "ఆరోగ్య అత్యవసర సంసిద్ధత",
    "first_aid_guidance": "ప్రథమ చికిత్స మార్గదర్శనం",
    "emergency_contacts": "అత్యవసర ఆరోగ్య సంరక్షణ పరిచయాలు",
    "medication_management": "మందుల నిర్వహణ",
    "allergy_alerts": "అలెర్జీ హెచ్చరికలు",

    // Holistic Wellness
    "mind_body_connection": "మనస్సు-శరీర సంబంధం",
    "spiritual_healing": "ఆధ్యాత్మిక వైద్య అభ్యాసాలు",
    "energy_healing": "శక్తి వైద్య పద్ధతులు",
    "chakra_balancing": "చక్ర సమతోలనం",
    "aura_cleansing": "ప్రకాశవలయ శుద్ధీకరణ",
    "holistic_integration": "సమగ్ర ఆరోగ్య సమగ్రత"
};
